import React from "react"
import PropTypes from "prop-types"
//import { useStaticQuery, graphql } from "gatsby"
import "bootstrap/dist/css/bootstrap.min.css"

import {Row, Col} from "react-bootstrap"

import "./layout.css"
import Navigation from "./Navbar/Navbar"
import TitleBar from "./TitleBar"
import Sidebar from "./Sidebar"
import Footer from "./Footer/Footer"

const Layout = ({ children, pageTitle }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  // `)

  
  return (
    <>
      <Navigation />
      <TitleBar pageTitle={ pageTitle } className="mb-4"/>
      {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
      <div className="container my-4"
      >
        <Row>
          <Col>
          <main className="site-content">{children}</main>
          </Col>
        </Row>
        {/* <Row>
          <Col sm={9}>
          <main className="site-content">{children}</main>
          </Col>
          <Col sm={3}>
            <Sidebar />
          </Col>
        </Row> */}
        
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;
